<template>
  <div class="assets" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang251') }}</span>
    </div>

    <div class="pd">
      <van-tabs v-model="navActive" color="#29B286" title-active-color="#29B286" title-inactive-color="#c8c9cc" class="van-tabs" @change="changeTab">
        <van-tab :title="$t('lang389')"></van-tab>
        <van-tab :title="$t('lang390')"></van-tab>
        <van-tab :title="$t('lang434')"></van-tab>
      </van-tabs>
      <div class="top_box" v-if="navActive == 0">
        <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
          <template #reference>
            <div class="btn" type="primary">{{ action.text }}</div>
          </template>
        </van-popover>
        <van-field v-model="areaId" :placeholder="$t('lang228')" class="input" right-icon="search" @click-right-icon="search" />
      </div>
      <div class="" v-if="navActive == 0">
        <div class="bare" v-if="list.length <= 0">
          <span>{{ $t('lang60') }}</span>
        </div>
        <div v-else class="container">
          <!-- <div class="navbar">
            <span
              v-for="(item, index) in navList"
              :key="index"
              @click="changeNav(item, index)"
              :style="{ color: navIndex == index ? '#000' : '', 'border-bottom': navIndex == index ? '1px solid #000' : '' }"
              >{{ item.key }}</span
            >
          </div> -->
          <div class="list">
            <div v-for="(item, index) in list" :key="index" class="li">
              <div class="box">
                <div class="box_item">
                  <div class="f-c">
                    <span class="num">{{ item.address_id }}</span>
                    <span class="amount">
                      {{
                        statusList.filter((it, idx) => {
                          return item.status == it.status && it.type_id == item.type_id;
                        })[0]?.text || ''
                      }}
                    </span>
                  </div>
                  <div class="f-c">
                    <span class="key ellipsis">{{ item.name }}</span>
                    <span class="key">{{ dateFormatFn(item.create_time) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="navActive == 1">
        <div class="pd1 goods_box" v-if="nft_list.length > 0">
          <div class="goods_list" v-for="(item, index) in nft_list" :key="index">
            <!-- <div class="tags3" v-if="item.type_id == 2 && item.status != 2 && item.status != 3">❤️</div> -->
            <div class="tags tags4" v-if="item.status == 0">{{ $t('lang192') }}</div>
            <div class="tags1" v-if="item.status == 1">{{ $t('lang403') }}</div>
            <div class="tags tags2" v-if="item.status == 2">{{ $t('lang146') }}</div>
            
            <div class="f">
              <van-image class="goods_list_img" radius="10" :src="item.thum" />
              <div class="right" style="flex: 2">
                <span class="title">{{ item.name }}</span>
                <!-- <div style="font-size: 11px">{{ $t('lang395') + 111 }}</div> -->
                <div class="cen">
                  <span class="f" v-if="item.price > 0">
                    <svg width="24" height="24" viewBox="22 0 96 100" xmlns="http://www.w3.org/2000/svg">
                      <path d="M70,35 C56,28 38,40 40,54 C40,64 50,74 70,66" fill="none" stroke="black" stroke-width="6" stroke-linecap="round" />
                      <line x1="52" y1="29" x2="52" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
                      <line x1="63" y1="29" x2="63" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
                    </svg>
                    <span class="money">{{ item.price }}</span>
                  </span>
                </div>
                <div style="font-size: 11px">{{ $t('lang393') + item.stock }}</div>
                <div style="font-size: 11px">{{ $t('lang394') + item.num }}</div>

                <div style="font-size: 13px">
                  <span>{{ dateFormatFn(item.create_time) }}</span>
                </div>
              </div>
            </div>

            <div class="btn_box" v-if="item.status == 1">
              <div class="buy">
                <van-button class="buy_btn btn1" type="primary" @click="cancelBuying(item)">{{ $t('lang391') }}</van-button>
              </div>
            </div>
          </div>
        </div>
        <div class="bare" v-if="nft_list.length <= 0">
          <span>{{ $t('lang82') }}</span>
        </div>
      </div>
      <div v-else-if="navActive == 2">
        <div class="pd1 goods_box" v-if="teacList.length > 0">
          <div class="goods_list" v-for="(item, index) in teacList" :key="index">
            <div class="tags tags4" v-if="item.status == 0">{{ $t('lang192') }}</div>
            <div class="tags1" v-if="item.status == 1 && item.type_id == 1">{{ $t('lang438') }}</div>
            <div class="tags1 tags5" v-if="item.status == 1 && item.type_id == 2">{{ $t('lang437') }}</div>
            <div class="tags tags2" v-if="item.status == 2">{{ $t('lang146') }}</div>

            <div class="f">
              <!-- <van-image class="goods_list_img" radius="10" :src="item.thum" /> -->
              <div class="right" style="flex: 2">
                <div class="cen">
                  <span class="f-sb" v-if="item.price > 0">
                    <span>{{ $t('lang436') }}</span>
                    <div class="f-r">
                      <svg width="24" height="24" viewBox="22 0 96 100" xmlns="http://www.w3.org/2000/svg">
                        <path d="M70,35 C56,28 38,40 40,54 C40,64 50,74 70,66" fill="none" stroke="black" stroke-width="6" stroke-linecap="round" />
                        <line x1="52" y1="29" x2="52" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
                        <line x1="63" y1="29" x2="63" y2="73" stroke="black" stroke-width="5.2" stroke-linecap="round" />
                      </svg>
                      <span class="money">{{ item.price }}</span>
                    </div>
                  </span>
                </div>
                <div class="f-sb">
                  <span>{{ $t('lang393') }}</span>
                  <span>{{ item.stock }}</span>
                </div>
                <div class="f-sb">
                  <span>
                    {{ $t('lang394') }}
                  </span>
                  <span>{{ item.num }}</span>
                </div>
                <div class="f-sb">
                  <span>{{ $t('lang199') + '：' }}</span>
                  <span>{{ dateFormatFn(item.create_time) }}</span>
                </div>
              </div>
            </div>

            <div class="btn_box" v-if="item.status == 1">
              <div class="buy">
                <van-button class="buy_btn btn1" type="primary" @click="cancelTrade(item)">{{ item.type_id == 1 ? $t('lang439') : $t('lang391') }}</van-button>
              </div>
            </div>
          </div>
        </div>
        <div class="bare" v-if="teacList.length <= 0">
          <span>{{ $t('lang82') }}</span>
        </div>
      </div>
    </div>
    <van-overlay :show="loading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="loading" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import { Dialog, Notify, Toast } from 'vant';
export default {
  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      total: 1,
      nickname: '',
      assets: 0,
      list: [],
      navActive: [],
      navActive: 0,
      nft_list: [],
      statusList: [],
      teacList: [],
      totalReward: 0,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [],
      action: { text: this.$t('lang201'), type_id: -1, status: -1 },
      areaId: '',
    };
  },
  mounted() {
    this.getOperateLog();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    navigation(name) {
      this.$router.push({ name });
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.page != -1) {
          this.page++; // 页数加 1
          if (this.navActive == 0) {
            this.getOperateLog(); // 触发加载更多
          } else if (this.navActive == 1) {
            this.getMyBuyingList(); // 触发加载更多
          } else if (this.navActive == 2) {
            this.getUserTeacList(); // 触发加载更多
          }
        }
      }
    },
    onSelect(action) {
      console.log(action);
      this.action = action;
      this.search();
    },
    search() {
      this.page = 1;
      this.list = []; // 重置列表数据
      this.getOperateLog(); // 触发重新获取列表数据
    },
    getMyBuyingList() {
      homeApi.getMyBuyingList({ page: this.page, product_id: this.$route.query.product_id, type_id: this.$route.query.type_id }).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          if (this.nft_list.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.nft_list = [...this.nft_list, ...res.data.data];
            // console.log(this.nft_list.length);
            if (this.nft_list.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    getUserTeacList() {
      homeApi.getUserTeacList({ page: this.page }).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          if (this.teacList.length >= res.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.teacList = [...this.teacList, ...res.data.data];
            if (this.teacList.length >= res.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    getOperateLog() {
      let params = {
        page: this.page,
        type_id: this.action.type_id,
        status: this.action.status,
        area_id: this.areaId,
      };
      homeApi.getOperateLog(params).then(res => {
        if (res.code == 200) {
          this.actions = [];
          this.statusList = res.data.statusList;
          this.actions = this.statusList.map(action => {
            return {
              type_id: action.type_id,
              status: action.status,
              text: action.text,
            };
          });
          this.actions.unshift({ text: this.$t('lang201'), type_id: -1, status: -1 });

          if (this.list.length >= res.data.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data.data];
            if (this.list.length >= res.data.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    changeTab() {
      this.page = 1;
      this.list = []; // 重置列表数据
      this.nft_list = [];
      this.teacList = [];
      if (this.navActive == 0) {
        this.getOperateLog(); // 触发重新获取列表数据
      } else if (this.navActive == 1) {
        this.getMyBuyingList(); // 触发重新获取列表数据
      } else if (this.navActive == 2) {
        this.getUserTeacList(); // 触发重新获取列表数据
      }
    },
    cancelBuying(item) {
      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang404'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.loading = true;
          homeApi
            .cancelBuying({ buying_id: item.id })
            .then(res => {
              if (res.code == 200) {
                _this.loading = false;
                _this.page = 1;
                _this.nft_list = [];
                _this.getMyBuyingList();
                Notify({ type: 'success', message: _this.$t('lang150') });
              } else {
                _this.loading = false;
                _this.$toast(res.msg);
              }
            })
            .catch(err => {
              _this.loading = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelTrade(item) {
      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang401'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.loading = true;
          homeApi
            .cancelTrade({ teac_id: item.id })
            .then(res => {
              if (res.code == 200) {
                _this.loading = false;
                _this.page = 1;
                _this.teacList = [];
                _this.getUserTeacList();
                Notify({ type: 'success', message: _this.$t('lang150') });
              } else {
                _this.loading = false;
                _this.$toast(res.msg);
              }
            })
            .catch(err => {
              _this.loading = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-c {
  display: flex;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.assets {
  height: 100vh;
  overflow: auto;
  padding: 50px 0 0;
  // background-color: #fafbfc;
  .van-tabs {
    // position: fixed;
    // top: 0;
    width: 100%;
    // z-index: 99;
  }
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .top_box {
    padding: 16px 16px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .input {
      width: calc(100% - 90px);
      border: 1px solid #29b286;
      border-radius: 20px;
    }
    ::v-deep .van-field__control {
      padding: 3px 12px;
    }
    ::v-deep .van-icon-search {
      font-size: 20px;
      color: #29b286;
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .navbar {
    position: relative;
    border-radius: 14px;
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      margin: 0 40px;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid #ffffff;
    }
  }
  .btn {
    color: #ffffff;
    height: 30px;
    width: 86px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    background-color: #29b286;
    border: none;
    // padding: 0 16px;
    white-space: nowrap;
    border-radius: 30px;
  }
  .total_box {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    font-size: 12px;
    color: #fff;
    height: 180px;
    padding: 30px 0 60px;
    background: linear-gradient(to right, #1ab986, #25d7bb);
    .f-sa {
      width: 100%;
    }
    .total {
      font-size: 28px;
      text-align: center;
      padding: 16px 0 6px;
      color: rgba(#fff, 1);
    }
    .text {
      font-size: 16px;
      font-weight: bold;
      color: rgba(#fff, 1);
    }
    .item {
      color: rgba(#fff, 0.8);
      width: 50%;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    .buy {
      position: absolute;
      right: 14px;
      bottom: 14px;

      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
        display: flex;
        align-items: flex-start;
      }
    }
    .buy1 {
      left: 14px;
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }

  .container {
    position: relative;
    margin: 14px 14px 0;
    border-radius: 14px;
    background-color: #fff;
  }
  .list {
    border-radius: 20px;
    padding: 0 8px;
    margin-top: 16px;
    margin: 16px 6px;
    .li {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 14px 0;
      border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);

      .box {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_item {
          width: 100%;
          display: flex;
          flex-direction: column;
          .key {
            color: #aaa;
            font-size: 12px;
          }
          .num {
            font-size: 12px;
            color: #000;
            padding-bottom: 16px;
          }
          .amount {
            color: #29b286;
            font-size: 16px;
          }

          .ssm {
            font-size: 10px;
          }
        }
      }
    }
  }
  ::v-deep .van-popover__action {
    border-bottom: 0.5px solid rgba(190, 190, 190, 0.55) !important;
  }
}
.ellipsis {
  overflow: hidden; /* 确保超出容器的文本被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 使用省略号表示文本超出 */
  max-width: 60%;
}
.goods_box {
  // margin: 14px;
  border-radius: 14px;
  .good_icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
.pd1 {
  padding: 16px 14px 14px;
  // height: auto;
}
.goods_list {
  position: relative;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  color: #000;
  padding: 14px;
  border-radius: 6px;
  // box-shadow: 0 4px 16px 0 rgba(53, 73, 93, 0.15);
  margin-bottom: 16px;
  // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
  background-color: #fff;
  // background-image: linear-gradient(90deg, rgba(217, 239, 239, 0.3) 0, rgba(217, 239, 239, 0.3) 0, rgba(225, 240, 242, 0.3) 100%, rgba(225, 240, 242, 0.3) 100%);

  .tags {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 10px;
    color: #fff;
    padding: 4px 14px;
    z-index: 99;
    background-color: #29b2b0;
    border-radius: 0 6px 0 6px;
  }
  .tags1 {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 10px;
    color: #fff;
    padding: 4px 14px;
    z-index: 99;
    background-color: #29b286;
    border-radius: 0 6px 0 6px;
  }
  .tags3 {
    position: absolute;
    left: 3px;
    top: 3px;
    z-index: 99;
    font-size: 15px;
  }
  .tags2 {
    background-color: #1e8df4;
  }
  .tags4 {
    background-color: #cccccc;
  }
  .tags5 {
    background-color: #179b9b;
  }
  &_img {
    width: 105px;
    height: 105px;
    border-radius: 10px;
    margin-right: 10px;
  }

  .right {
    width: calc(100% - 115px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 13px;
    box-sizing: border-box;
    padding: 18px 0 6px;
    .title {
      width: 100%;
      overflow: hidden; /* 确保超出容器的文本被裁剪 */
      white-space: nowrap; /* 确保文本在一行内显示 */
      text-overflow: ellipsis; /* 使用省略号表示文本超出 */
    }

    .time_text {
      color: #7f7f7f;
      font-weight: normal;
      font-size: 10px;
      text-decoration: line-through;
    }
    .cen {
      color: #000;
      // font-size: 12px;
    }
    .f-sb {
      line-height: 200%;
    }
    .money {
      font-size: 15px;
      color: #29b286;
      margin-left: -8px;
    }
    .ssm {
      font-size: 10px;
      font-weight: normal;
    }
    .mon_t {
      color: #3d3d3d;
      font-weight: normal;
    }
    .yel {
      background-color: #f9f6e5;
      font-weight: normal;
      margin-left: 8px;
      padding: 0px 8px;
      border-radius: 16px;
      white-space: nowrap;
      .count {
        color: #f7c35d;
        font-size: 9px;
      }
    }
    .green {
      width: fit-content;
      color: #29b286;
      background-color: #ddf2e7;
      font-size: 10px;
      font-weight: normal;
      padding: 2px 6px;
      border-radius: 6px;
    }
    .t2 {
      text-decoration: none;
    }
  }
  .buy {
    display: flex;
    // align-items: flex-end;
    // justify-content: flex-end;
    &_btn {
      height: 32px;
      width: 100%;
      text-align: center;
      line-height: 32px;
      font-size: 12px;
      border: none;
      // padding: 0 20px;
      white-space: nowrap;
      border-radius: 30px;
      box-sizing: border-box;
      // padding: 0 10px;
      // overflow: hidden; /* 确保超出容器的文本被裁剪 */
      // white-space: nowrap; /* 确保文本在一行内显示 */
      // text-overflow: ellipsis; /* 使用省略号表示文本超出 */
      border: 1px solid #29b286;
      background-color: #29b286;
    }
    .btn1 {
      color: #29b286;
      background-color: #fff;
    }
    .btn3 {
      width: 98px;
      color: #b9b9b9;
      padding: 0 20px;
      border: 1px solid #b9b9b9;
      background-color: #fff;
    }
    .btn4 {
      width: 96px;
    }
  }
  .buy1 {
    justify-content: flex-end;
  }
}
.area {
  color: #363636;
  font-size: 13px;
  padding: 20px 30px;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .title {
    color: #000;
    font-size: 15px;
    text-align: center;
    font-weight: bold;
    // padding: 0 0 14px;
  }
  .vanlist {
    max-height: 350px;
    overflow: auto;
    box-sizing: border-box;
    margin: 20px 0;
    border: none !important;

    .item {
      padding: 12px 0 !important;
      border-bottom: 0.5px solid rgba(190, 190, 190, 0.15);
    }
  }
  .box {
    margin: 20px 0;
    .f-r,
    .f-s {
      padding: 6px 0;
    }
    .f-r span:first-child,
    .f-s span:first-child {
      padding-right: 8px;
      white-space: nowrap;
    }
    .d {
      display: flex;
      align-items: flex-end;
    }
    .input {
      // width: 100%;
      // border: 1px solid #29b286;
      // border-radius: 20px;
      width: 150px;
      border-bottom: 0.5px solid rgba(27, 27, 27, 0.15);
    }
    .k {
      padding-top: 6px;
    }
    .input1 {
      width: 100%;
      border-bottom: 0.5px solid rgba(27, 27, 27, 0.15);
      // ::v-deep .van-field__body,
      // ::v-deep .van-field__control {
      //   height: 32px !important;
      // }
    }

    .van-cell {
      padding: 0 !important;
    }
    .s {
      font-size: 11px;
      color: #999999;
      width: 70%;
    }
  }
  .submit {
    width: 100%;
    // position: fixed;
    bottom: 30px;
    box-sizing: border-box;
    &_btn {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      background-color: #29b286;
      border: none;
      white-space: nowrap;
      border-radius: 30px;
    }
  }

  ::v-deep .van-field__control {
    padding: 0 12px 0;
    font-size: 12px;
  }

  ::v-deep .van-hairline--top-bottom::after,
  ::v-deep.van-hairline-unset--top-bottom::after {
    border: none;
  }
}
.btn_box {
  padding-top: 14px;
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f-r {
  display: flex;
  align-items: center;
}
.f {
  display: flex;
}
.f-s {
  display: flex;
  align-items: flex-start;
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>